import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const NewsletterModule = {
  namespaced: true,

  state: {
    newsletter: {},
    newsletters: []
  },

  getters: {
  },

  actions: {
    async getNewsletter ({ commit, state }, newsletterId) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/newsletters/' + newsletterId
      ).then((resp) => {
        commit('storeNewsletter', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getNewslettersByDateRange ({ commit, state }, dateStart, dateEnd) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/newsletters_by_date_range/'
      ).then((resp) => {
        commit('storeNewsletters', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async setAttachments ({ commit, state }, attachments) {
      commit('storeNewslettersAttachments', attachments)
    }
  },

  mutations: {
    storeNewsletter (state, payload) {
      state.newsletter = processSuccess(payload, baseOpts)
    },

    storeNewsletterAttachments (state, payload) {
      state.newsletter.attachments = processSuccess(payload, baseOpts)
    },

    storeNewsletters (state, payload) {
      state.newsletters = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/NewsletterModule.js